import React, { useState, useEffect } from "react";
import axios from "axios";
import './ProfilePage.css'; 
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
import { clearAuthData, getToken } from "../utils/AuthStorage";

const ProfilePage = () => {
    const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      navigate("/welcome");
    }
  }, [navigate]); 
  
  useEffect(() => {
    const token = getToken();
    if (!token) {
      setError("No token found, please log in again.");
      setLoading(false);
      return;
    }

    axios.get(`${process.env.REACT_APP_BASE_URL}/user`, {
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${token}`,
      },
    })
    .then((response) => {
      setUserDetails(response.data.data); 
      setLoading(false);
    })
    .catch((err) => {
      setError("Failed to fetch user details.");
      setLoading(false);
    });
  }, []);

 
  const handleLogout = () => {
    clearAuthData();
    navigate('/welcome') 
  };


  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <Header heading="Profile" />
      <div className="profile-container">
        <h2>User Profile</h2>
        <div className="profile-info">
          <div className="profile-detail">
            <strong>First Name: </strong>
            <span>{userDetails.firstName}</span>
          </div>
          <div className="profile-detail">
            <strong>Last Name: </strong>
            <span>{userDetails.lastName}</span>
          </div>
          <div className="profile-detail">
            <strong>Email: </strong>
            <span>{userDetails.email}</span>
          </div>
          <div className="profile-detail">
            <strong>Mobile: </strong>
            <span>{userDetails.mobileCode} {userDetails.mobile}</span>
          </div>
          <div className="profile-detail">
            <strong>Status: </strong>
            <span className={`profile-status ${userDetails.isDeleted ? 'deleted' : ''}`}>
              {userDetails.isDeleted ? "Deleted" : "Active"}
            </span>
          </div>
        </div>
        {/* Logout Button */}
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </>
  );
};

export default ProfilePage;
